import React from 'react';
//Components
import Card from '../components/card/card';
import Layout from '../components/layout';

export default function CardTemplate({ pageContext }) {
  return (
    <Layout>
      <Card
        background={pageContext.brand.background.mobile}
        brand={pageContext.brand}
        contact={pageContext.contact}
        logo={pageContext.brand.logos.form}
        seller={pageContext.seller}
      />
    </Layout>
  );
}
